import React, { useEffect, useState, useRef } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import PublicLayout from "web/components/PublicLayout";
import LandingFooter from "web/pages/public/landing-page/LandingFooter";
import DigitalSupplier from "../../../../assets/images/1selfmanage.png";
import SelfManagedHandCellPhone from "web/assets/images/self-managed_hand-cell-phone.png"
import GetIcon1 from "../../../../assets/images/6get.svg";
import GetIcon2 from "../../../../assets/images/7get.svg";
import GetIcon3 from "../../../../assets/images/8get.svg";
import GetIcon4 from "../../../../assets/images/9get.svg";
import GetIcon5 from "../../../../assets/images/10get.svg";
import tickIcon from "../../../../assets/images/tickIcon34.svg";
import crossIcon from "../../../../assets/images/crossIcon34.svg";
import ButtonSet from "../ButtonSet";
import {
  Container,
  Wrapper,
} from "web/pages/public/landing-page/SelfManaged/SelfManagedstyled";
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

const data = [
  {
    title: "On-Demand Procurement",
    icon: GetIcon1,
    description: [
      "Immediate reach and access to pallet supply",
      "Centralized, vetted supplier network",
    ],
  },
  {
    title: "Go-to-Market Flexibility",
    icon: () => <img src={GetIcon2} id="icon2-id" alt="icon" />,
    description: [
      "Transact with your existing business",
      "partners or on the open marketplace",
      "Setup recurring orders or posts",
    ],
  },
  {
    title: "Operational Latitude ",
    icon: GetIcon3,
    description: [
      "Single to multi-location setup",
      "Unlimited user access",
      "Location spend thresholds",
    ],
  },
  {
    title: "The Power of a TMS",
    icon: GetIcon4,
    description: ["Order Tracking & Management", "Document Repository"],
  },
  {
    title: "Cost Optimization & Control",
    icon: GetIcon5,
    description: ["Reporting & Analytics", "Market Visibility"],
  },
];

const CardDetails = ({ item, index, isOpen, onOpen, onClose }) => {
  const ref = useRef();
  const dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    let token = localStorage.getItem('token')
    let isAdminOrUserAccount = localStorage.getItem('accountType')
    if (isAdminOrUserAccount && token) {
      if (isAdminOrUserAccount === 'Admin') history.push('/admin')
      else history.push('/dashboard')
    } else {
      dispatch(logoutAdmin())
      dispatch(logoutClearRedux())
      localStorage.clear()
      sessionStorage.clear()
    }
  }, [])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClose]);

  return (
    <div className="card" data-aos="fade-right" data-aos-delay={index * 300} ref={ref}>
      <div className="text-box">
        <h4>{item?.title}</h4>
        <p onClick={onOpen}>Read more</p>
        <div className={`hover-box ${isOpen ? 'active' : ''}`}>
          <img
            src={crossIcon}
            onClick={onClose}
          />
          <h4>{item?.title}</h4>
          <ul>
            {item?.description?.map((desc, descIndex) => (
              <li key={index + "description-" + descIndex}>
                <img src={tickIcon} /> {desc}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="img-box">
        {typeof item.icon === "function" ? (
          item.icon()
        ) : (
          <img src={item.icon} alt="icon" />
        )}
      </div>
    </div>
  );
};

CardDetails.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  isOpen: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
};

const SelfManaged = () => {
  const location = useLocation();
  const whatRef = useRef(null);
  const howRef = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
      once: true,
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.hash === "#what") {
      if (whatRef.current) {
        // whatRef.current.scrollIntoView({ behavior: 'smooth' });
        const element = whatRef.current;
        const yOffset = -80; // Adjust the offset as needed
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#how") {
      if (howRef.current) {
        // howRef.current.scrollIntoView({ behavior: "smooth" });
        const element = howRef.current;
        const yOffset = -80; // Adjust the offset as needed
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  let history = useHistory();

  const [openIndex, setOpenIndex] = useState(null);

  const handleOpen = (index) => {
    setOpenIndex(index);
  };

  const handleClose = () => {
    setOpenIndex(null);
  };

  return (
    <>
      <Helmet title="PalletTrader | Self Service">
        <meta
          name="description"
          content="Buy pallets easily with PalletTrader’s self-managed online marketplace. Source, track, and manage your pallet purchases while staying in control."
        />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/self-managed-services" />
      </Helmet>
      <PublicLayout transparentHeader={true}>
        <Container>
          <Wrapper>
            <section className="our_expertise suppliers mb-0">
              <div className="expertise_overlay self">
                <div data-aos="fade-right" data-aos-delay="100">
                  <h2>Self</h2>
                  <h2>Service</h2>
                </div>
              </div>
            </section>
            <section className="pallet_faq">
              <div className="faq-head">
                <h2>Control. Convenience. Choice.</h2>
                <p>
                  PalletTrader.com is a digital marketplace and order management
                  platform built for single locations, or national networks
                  looking to streamline their fragmented procurement and order
                  management processes.
                </p>
              </div>
            </section>
            <section className="digital_supplier">
              <div className="digital_supplier_img">
                <img
                  id="gryimg"
                  src={SelfManagedHandCellPhone}
                  alt="icon"
                  data-aos="fade-in"
                  data-aos-delay="100"
                />
              </div>
              <div className="digital_supplier-text">
                <div data-aos="fade-up" data-aos-delay="100">
                  <h2>Enterprise System Power. One Click Simplicity</h2>
                  <p>
                    PalletTrader’s self-service offering was built to connect
                    pallet buyers with a centralized network of pallet
                    suppliers. This all-encompassing platform offers users a
                    complete procurement and order management system.
                  </p>
                </div>
              </div>
            </section>
            {/* <section className="what_you_get" id="what">
              <div>
                <h2>What You Get.</h2>
                <p>All the Tools. All the Technology. It’s All You Need.</p>
              </div>
              <div className="what_you_get_option">
                <div
                  className="img-wrp"
                  data-aos="fade-right"
                  data-aos-delay="000"
                >
                  <div className="gry-bg">
                    <img src={GetIcon1} alt="icon" />
                  </div>
                  <div className="blue-bg">
                    <h3>On-Demand Procurement</h3>
                    <ul>
                      <li>Immediate reach and access to pallet supply</li>
                      <li>Centralized, vetted supplier network</li>
                    </ul>
                  </div>
                </div>
                <div
                  className="img-wrp"
                  data-aos="fade-right"
                  data-aos-delay="300"
                >
                  <div className="gry-bg">
                    <img src={GetIcon2} alt="icon" />
                  </div>
                  <div className="blue-bg">
                    <h3>Go-to-Market Flexibility</h3>
                    <ul>
                      <li>
                        Transact with your existing business partners or on the
                        open marketplace
                      </li>
                      <li>Setup recurring orders or posts</li>
                    </ul>
                  </div>
                </div>
                <div
                  className="img-wrp"
                  data-aos="fade-right"
                  data-aos-delay="600"
                >
                  <div className="gry-bg">
                    <img src={GetIcon3} alt="icon" />
                  </div>
                  <div className="blue-bg">
                    <h3>Ultimate Operational Latitude</h3>
                    <ul>
                      <li>Single to multi-location setup</li>
                      <li>Unlimited user access</li>
                      <li>Location spend thresholds</li>
                    </ul>
                  </div>
                </div>
                <div
                  className="img-wrp"
                  data-aos="fade-right"
                  data-aos-delay="900"
                >
                  <div className="gry-bg">
                    <img src={GetIcon4} alt="icon" />
                  </div>
                  <div className="blue-bg">
                    <h3>The Power of a TMS</h3>
                    <ul>
                      <li>Order Tracking & Management</li>
                      <li>Document Repository</li>
                    </ul>
                  </div>
                </div>
                <div
                  className="img-wrp"
                  data-aos="fade-right"
                  data-aos-delay="1200"
                >
                  <div className="gry-bg">
                    <img src={GetIcon5} alt="icon" />
                  </div>
                  <div className="blue-bg">
                    <h3>Cost Optimization & Control</h3>
                    <ul>
                      <li>Reporting & Analytics</li>
                      <li>Market Visibility</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section> */}

            <div className="what_you_get" ref={whatRef} id="what">
              <div className="what_you_get-container">
                <h2>What you get.</h2>
                <p>All the Tools. All the Technology. It's All You Need.</p>

                <div className="cards-container">
                  {data?.map((item, index) => (
                    <CardDetails
                      key={"card-item" + index}
                      item={item}
                      index={index}
                      isOpen={openIndex === index}
                      onOpen={() => handleOpen(index)}
                      onClose={handleClose}
                    />
                  ))}
                </div>
              </div>
            </div>


            <section className="pallet_faq" id="how" ref={howRef}>
              <div className="faq-head">
                <h2 className="how">How it works.</h2>
                <p>
                  Completely Transform Your Pallet Management Process in Three
                  Easy Steps.
                </p>
              </div>
            </section>
            <section className="color_box_wrp mb-0">
              <div className="list-wrapper">
                <div
                  className="item-container first"
                  data-aos="flip-up"
                  data-aos-delay="000"
                >
                  <div className="number-box">
                    <span className="number">1</span>
                    <span className="number-shadow">1</span>
                  </div>
                  <div className="icon-box">
                    <p className="paras">Account Setup</p>
                  </div>
                  <div className="bg-set">
                    <div className="traingle"></div>
                    <div className="description-box">
                      <ul>
                        <li>Register & set your account preferences</li>
                        <li>Add your locations, assign user permissions</li>
                        <li>
                          Connect to your incumbent partners (private community)
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  className="item-container second"
                  data-aos="flip-up"
                  data-aos-delay="200"
                >
                  <div className="number-box">
                    <span className="number">2</span>
                    <span className="number-shadow">2</span>
                  </div>
                  <div className="icon-box">
                    <p className="paras">Three Ways</p>
                    <p className="paras">to Procure</p>
                  </div>
                  <div className="bg-set">
                    <div className="traingle"></div>
                    <div className="description-box">
                      <ul>
                        <li>
                          Search & buy pallets from the available posted
                          inventory
                        </li>
                        <li>Post your needs to the open marketplace</li>
                        <li>Tender your loads directly to your incumbents, or new supplier partners</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  className="item-container third"
                  data-aos="flip-up"
                  data-aos-delay="400"
                >
                  <div className="number-box">
                    <span className="number">3</span>
                    <span className="number-shadow">3</span>
                  </div>
                  <div className="icon-box">
                    <p>Operationalize</p>
                  </div>
                  <div className="bg-set">
                    <div className="traingle"></div>
                    <div className="description-box">
                      <ul>
                        <li>Accept bids/offers manually or automatic</li>
                        <li>Order management console from order to payment</li>
                        <li>Download all paperwork and receipts</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="pallet_faq last">
              <div className="faq-head">
                <h2 className="market">
                  Search the Marketplace.
                </h2>
                <h2 className="market">Request a Quote. Experience Innovation.</h2>
                <ButtonSet />
              </div>
            </section>
          </Wrapper>
        </Container>
        <LandingFooter />
      </PublicLayout>
    </>
  );
};

export default SelfManaged;
